<template>
  <div class="add-product-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'company-admin-campaings-all-campaings'})"
           class="back-link">
        <svg class="icon"
             width="30px"
             height="30px"
             viewBox="0 0 30 30"
             version="1.1">
          <path d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                id="path-1">
          </path>
        </svg>
        <p>Back to Campaigns</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'company-admin-campaings-all-campaings'})"
             class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addCampaign">Save Campaign</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-campaign-container">
      <p class="title">Schedule Campaign</p>

      <div class="col">
        <div class="row">
          <primary-input v-model="campaign.campaign_name"
                         class="campaign-name col-md-8 pl-0"
                         type="text"
                         placeholder="Enter campaign name"
                         name="Campaign name" />
          <primary-select class="type col-md-4 pl-0"
                          v-model="campaign.type"
                          name="Type">
            <option v-for="(i, k) in type"
                    :key="k">{{i}}</option>
          </primary-select>
        </div>
        <div class="help is-danger" v-if="campaignErrors">
          {{campaignErrors.campaign_name}}
        </div>
        <div class="row">
          <el-radio v-model="selectedType" label="Phone Numbers" class="col-md-2 campaign-radio-button pl-0 pr-0"></el-radio>
           <search-input type="number"
                         class="col-md-10"
                         :disabled="selectedType != 'Phone Numbers'"
                        v-model="SearchNumber"
                        placeholder="Search numbers"
                        name="phone numbers:" />
          <div v-if="SearchNumber > 0"
               class="autocomlete-container">
            <div v-for="(phone, k) in selectedStates"
                 @click="addNumber(phone)"
                 :key="k"
                 class="autocomlete-item">
              {{phone}}
            </div>
          </div>
<!--          <div class="primary-input-container col-md-12 pl-0">-->
<!--            <p class="pimary-input-title">Phone Numbers:</p>-->
<!--            <multiselect v-model="SearchNumber"-->
<!--                         :options="phoneNumbers"-->
<!--                         :multiple="true"-->
<!--                         :close-on-select="false"-->
<!--                         :clear-on-select="false"-->
<!--                         :preserve-search="true"-->
<!--                         placeholder="Pick Numbers"-->
<!--                         label="phone"-->
<!--                         track-by="phone"-->
<!--                         :preselect-first="true">-->
<!--              <template slot="selection"-->
<!--                        slot-scope="{ values, search, isOpen, option }">-->
<!--                <span class="multiselect__single"-->
<!--                      v-if="values.length &amp;&amp; !isOpen">{{ values.length }} numbers selected-->
<!--                </span>-->
<!--              </template>-->
<!--            </multiselect>-->
<!--          </div>-->
        </div>
         <p class="chips-header">Frequently used</p>
        <div class="row">
          <div class="chip">
            <p>295-635-6179</p>
            <svg class="icon"
                 width="30px"
                 height="30px"
                 viewBox="0 0 30 30"
                 version="1.1">
              <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594)"
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1">
              </path>
            </svg>
          </div>
        </div>
         <p v-if="slectedPhoneNumbers.length > 0"
           class="chips-header-selected">SELECTED</p>
        <div class="chips-row row">
          <div v-for="(number, k) in slectedPhoneNumbers"
               :key="number.index"
               class="chip-selected">
            <p>{{number}}</p>
            <svg @click="removeNumber(k)"
                 class="icon"
                 width="30px"
                 height="30px"
                 viewBox="0 0 30 30"
                 version="1.1">
              <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594)"
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1">
              </path>
            </svg>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="row">
          <!-- <date-picker v-model="campaign.start_date"
                       name="start date"
                       placeholder="DD MM YYYY"
                       class="start-date" /> -->
          <div class="primary-input-container start-date">
            <p class="pimary-input-title">start date</p>
            <div class="primary-select-wrapper">
              <date-picker v-model="campaign.start_date"
                           calendar-class="calendar-class"
                           format="yyyy-MM-dd"
                           wrapper-class="date-wrapper"
                           placeholder="DD MM YYYY"
                           input-class="date-picker" />
              <img src="../../../assets/Icon/Arrow/Down.svg"
                   class="icon-down"
                   alt="">
            </div>
          </div>
          <!-- <primary-select class="list"
                          v-model="recipient"
                          name="list">
            <option disabled
                    value=" ">Select Recipient List</option>
            <option v-for="(recipient, k) in recipients"
                    :key="k"
                    :value="recipient.recipient_uuid">{{recipient.recipient_name}}</option>
          </primary-select> -->

          <div class="list primary-input-container">
            <p class="pimary-input-title">Select Recipient List</p>
            <multiselect v-model="selctedRecipients"
                         :options="recipients"
                         :value="recipients.recipient_name"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         placeholder="Pick Recipients"
                         label="recipient_name"
                         track-by="recipient_uuid"
                         :preselect-first="true">
              <template slot="selection"
                        slot-scope="{ values, search, isOpen, option }">
                <span class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen">{{ values.length }} recipients selected
                </span>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="row start-date" v-if="campaignErrors">
          <div class="help is-danger" >
            {{campaignErrors.start_date}}
          </div>
          <div class="help is-danger list">
            {{campaignErrors.recipients}}
          </div>
        </div>
         <div class="row">
           <el-radio v-model="selectedType" label="Groups/Routes" class="col-md-2 campaign-radio-button pl-0"></el-radio>
          <search-input type="text"
                        :disabled="selectedType != 'Groups/Routes'"
                        class="col-md-10 pr-0 pl-0"
                        placeholder="Search groups"
                        name="Groups/Routes:" />
        </div>
         <p class="chips-header">Frequently used</p>
        <div class="row">
          <div class="chip">
            <p>Group Name</p>
            <svg class="icon"
                 width="30px"
                 height="30px"
                 viewBox="0 0 30 30"
                 version="1.1">
              <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594)"
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1">
              </path>
            </svg>
          </div>
        </div>
         <p class="chips-header-selected">SELECTED</p>
        <div class="row">
          <div class="chip-selected">
            <p>Group 1 Name</p>
            <svg class="icon"
                 width="30px"
                 height="30px"
                 viewBox="0 0 30 30"
                 version="1.1">
              <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594)"
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1">
              </path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="add-campaign-container">
      <div class="nav-header">
        <p @click="currentMessage = 'message'"
           :class="{active: currentMessage === 'message'}">Message #1</p>
        <!-- <p @click="currentMessage = 'message2'"
           :class="{active: currentMessage === 'message2'}"
           v-if="campaign.type === 'Long Code'">Message #2</p>
        <p @click="currentMessage = 'message3'"
           :class="{active: currentMessage === 'message3'}"
           v-if="campaign.type === 'Long Code'">Message #3</p> -->
      </div>
      <div class="add-campaign-body">
        <div class="col">
          <text-area v-if="currentMessage === 'message' "
                     placeholder="Enter message content"
                     maxlength="160"
                     class="text-area"
                     v-model="campaign.text"
                     name="messages" />
          <text-area v-if="currentMessage === 'message2' "
                     placeholder="Enter message content"
                     maxlength="160"
                     class="text-area"
                     v-model="message2"
                     name="messages" />
          <text-area v-if="currentMessage === 'message3' "
                     placeholder="Enter message content"
                     maxlength="160"
                     class="text-area"
                     v-model="message3"
                     name="messages" />
          <p class="text-area-caption">Each Message can be 160 characters max or 70 charcters using unicode (like emojis)</p>
        </div>
        <div class="col">
          <p class="token-title">Click on button below to insert personalization token to your message content</p>
          <div class="token-container">
            <secondary-button @click.native="AddToTheMessage('phone')"
                              class="secondary-button">phone</secondary-button>
            <secondary-button @click.native="AddToTheMessage('first_name')"
                              class="secondary-button">first_name</secondary-button>
            <secondary-button @click.native="AddToTheMessage('last_name')"
                              class="secondary-button">last_name</secondary-button>
            <secondary-button @click.native="AddToTheMessage('from')"
                              class="secondary-button">from</secondary-button>
          </div>
        </div>
      </div>
    </div>
    <div class="add-campaign-container">
      <div class="add-campaign-body">
        <div class="col">

          <p class="additional-title">Run Monday thru Friday</p>
          <check-box :height="24"
                     :width="24"
                     @click.native="WeekdaysOnly"
                     class="check-box-container"
                     label="Weekdays Only" />
          <div class="time-container"
               v-for="(times, k) in campaign.times"
               :key="k">
            <primary-select v-model="times.day"
                            class="weekdays-from"
                            name="weekdays">
              <option :value="weekday.toLowerCase().slice(0,3)"
                      v-for="(weekday, k) in weekdays"
                      :key="k">{{weekday}}</option>
            </primary-select>
            <primary-select v-model="times.start_time"
                            class="run-from"
                            name="run from">
              <option :value="time"
                      v-for="(time, k) in time"
                      :key="k">{{time.slice(0, 5)}}</option>
            </primary-select>
            <primary-select v-model="times.end_time"
                            class="run-until"
                            name="run until">
              <option :value="time"
                      v-for="(time, k) in time"
                      :key="k">{{time.slice(0, 5)}}</option>
            </primary-select>
          </div>
          <div class="times-menu-container">
            <p class="add-more"
               @click="addTime">ADD MORE</p>
            <p class="remove"
               @click="removeTime">REMOVE</p>
          </div>

          <primary-select v-model="campaign.sms_per_sec"
                          class="delivery-speed"
                          name="delivery speed">
            <option :value="speed"
                    v-for="(speed, k) in deliverySpeed"
                    :key="k">{{speed}} msg/minute</option>
          </primary-select>
          <check-box :height="16"
                     :width="16"
                     class="check-box-container"
                     label="Areacode Matching Only" />

        </div>
        <!-- <div class="col">

          <p class="additional-title">Verify wireless numbers additional cost</p>
          <check-box :height="24"
                     :width="24"
                     class="check-box-container"
                     label="Carrier Lookup" />

          <primary-select class="delivery-speed"
                          name="Status URL" />
        </div> -->
      </div>

    </div>
    <!-- <div v-if="campaign.type === 'Auto Responder'"
         class="add-campaign-container">
      <div class="add-campaign-body">
        <div class="col">

          <primary-input class="delivery-speed"
                         type="text"
                         placeholder="We will send an email when a new request is posted"
                         name="Notification Email" />
          <check-box :height="24"
                     :width="24"
                     class="check-box-container"
                     label="User Area Code Mapping" />

        </div>
      </div>

    </div> -->
  </div>
</template>

<script>
import { format } from "date-fns";
export default {
  components: {
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    TextArea: () => import("@/components/Inputs/TextArea.vue"),
    CheckBox: () => import("@/components/Inputs/CheckBox.vue"),
    DatePicker: () => import("vuejs-datepicker")
  },
  data: () => ({
    selectedType: null,
    campaign: {
      times: [
        {
          end_time: "23:00",
          start_time: "00:00",
          day: "mon"
        }
      ],
      start_date: "",
      text: "",
      campaign_name: "",
      type: "broadcast",
      recipients: [],
      sms_per_sec: 1
    },
    ShowWeekdaysOnly: false,
    currentMessage: "message",
    message: "",
    message2: "",
    message3: "",
    // type: ["Long Code", "Auto Responder"],
    type: ["broadcast", "one to one", "recurring"],
    recipients: [],
    phoneNumbers: [],
    slectedPhoneNumbers: [],
    SearchNumber: "",
    recipient: " ",
    selctedRecipients: [

    ],
    deliverySpeed: [1, 15, 30, 60, 90, 120],
    campaignErrors: null,
    WeekdaysArray: [
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "mon"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "tue"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "wed"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "thu"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "fri"
      }
    ],
    fullTimes: [
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "mon"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "tue"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "wed"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "thu"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "fri"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "sat"
      },
      {
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "sun"
      }
    ],
    weekdays: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    time: [
      "00:00:00+02:00",
      "01:00:00+02:00",
      "02:00:00+02:00",
      "03:00:00+02:00",
      "04:00:00+02:00",
      "05:00:00+02:00",
      "06:00:00+02:00",
      "07:00:00+02:00",
      "08:00:00+02:00",
      "09:00:00+02:00",
      "10:00:00+02:00",
      "11:00:00+02:00",
      "12:00:00+02:00",
      "13:00:00+02:00",
      "14:00:00+02:00",
      "15:00:00+02:00",
      "16:00:00+02:00",
      "17:00:00+02:00",
      "18:00:00+02:00",
      "19:00:00+02:00",
      "20:00:00+02:00",
      "21:00:00+02:00",
      "22:00:00+02:00",
      "23:00:00+02:00"
    ]
  }),
  created() {
    this.$store
      .dispatch("GetRecipientList", { page: "", search: "" })
      .then(res => {
        this.recipients = res.items;
      });
    // this.$store
    //   .dispatch("GetCompany", this.$store.state.user.user.company_uuid)
    //   .then(res => {
    //     this.phoneNumbers = [{ phone: res.contact.phone }];
    //     this.SearchNumber = [{ phone: res.contact.phone }];
    //   });
    this.$store
            .dispatch("GetAniList")
            .then(res => {
              this.phoneNumbers = res.items;
              console.log("this.phoneNumbers",this.phoneNumbers)
              this.aniGroupNames = res.items.map((item) => {
                return { phone: item.ani_group_name, id: item.ani_group_uuid };
              })
            });
    this.$store.dispatch("GetCampaign", this.$route.params.id).then(res => {
      this.campaign.times = res.times;
      this.campaign.start_date = res.start_date;
      this.campaign.text = res.text;
      this.campaign.campaign_name = res.campaign_name;
      this.campaign.type = res.type;
      this.campaign.sms_per_sec = res.sms_per_sec;
      res.recipients.forEach(el => {
        this.$store.dispatch("GetRecipient", el).then(res => {
          this.selctedRecipients.push(res);
        });
      });
    });
  },
  //   campaign: {
  //   times: [
  //     {
  //       end_time: "23:00",
  //       start_time: "00:00",
  //       day: "mon"
  //     }
  //   ],
  //   start_date: "",
  //   text: "",
  //   campaign_name: "",
  //   type: "broadcast",
  //   recipients: [],
  //   sms_per_sec: 1
  // },

  computed: {
    selectedStates() {
      if (this.phoneNumbers.length) {
        return this.phoneNumbers[0].items.filter(el => el.toLowerCase().indexOf(this.SearchNumber.toLowerCase()) > -1);
      }
      return [];

    }
  },
  methods: {
    WeekdaysOnly() {
      if (!this.ShowWeekdaysOnly) {
        this.ShowWeekdaysOnly = true;
        this.campaign.times = this.WeekdaysArray;
      } else {
        this.ShowWeekdaysOnly = false;
        this.campaign.times = [];
        this.campaign.times = [
          {
            end_time: "23:00:00+02:00",
            start_time: "00:00:00+02:00",
            day: "mon"
          }
        ];
      }
    },
    addNumber(number) {
      this.SearchNumber = null;
      this.slectedPhoneNumbers.push(number);
    },
    removeNumber(index) {
      this.slectedPhoneNumbers.splice(index, 1);
    },
    AddToTheMessage(word) {
      if (this.currentMessage === "message") {
        let newMessage = this.campaign.text + "{{user." + word + "}}";
        if (newMessage.length < 160) {
          this.campaign.text = newMessage;
        }
      }
      if (this.currentMessage === "message2") {
        let newMessage = this.message2 + "{ " + word + " }";
        if (newMessage.length < 160) {
          this.message2 = newMessage;
        }
      }
      if (this.currentMessage === "message3") {
        let newMessage = this.message3 + "{ " + word + " }";
        if (newMessage.length < 160) {
          this.message3 = newMessage;
        }
      }
    },

    addTime() {
      this.campaign.times.push({
        end_time: "23:00:00+02:00",
        start_time: "00:00:00+02:00",
        day: "sun"
      });
    },
    removeTime() {
      this.campaign.times.pop();
    },

    addCampaign() {
      this.selctedRecipients.forEach(el => {
        this.campaign.recipients.push(el.recipient_uuid);
      });
      this.campaign.start_date = format(this.campaign.start_date, "YYYY-MM-DD");
      if (this.campaign.times.length === 0) {
        this.campaign.times = this.fullTimes;
        this.$store
          .dispatch("PatchCampaign", {
            data: this.campaign,
            campaign_uuid: this.$route.params.id
          })
          .then(() => {
            this.$swal("Edited!", "Your campaign has been edited.", "success");
            this.$router.push({
              name: "company-admin-campaings-all-campaings"
            });
          })
          .catch(err => {
            this.$snotify.error(err.response.data.errors[0]);
          });
      } else {
        this.$store
          .dispatch("PatchCampaign", {
            data: this.campaign,
            campaign_uuid: this.$route.params.id
          })
          .then(() => {
            this.$swal("Edited!", "Your campaign has been edited.", "success");
            this.$router.push({
              name: "company-admin-campaings-all-campaings"
            });
          })
          .catch(err => {
            if (err.response.data.errors) {
              this.campaignErrors = err.response.data.errors[0];
              setTimeout(() => {
                this.campaignErrors = null;
              }, 6000);
            } else {
              this.$snotify.error(err.response.data.errors[0].items.toString(), {
                timeout: 4000
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss">
.add-product-container {
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin: 20px 0;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 150px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-campaign-container {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    padding: 15px;
    box-sizing: border-box;
    height: fit-content;
    width: 100%;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    .title {
      width: 100%;
      height: 30px;
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      margin-bottom: 15px;
    }
    .col {
      width: calc(50% - 7.5px);
      height: fit-content;
      .row {
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .autocomlete-container {
          box-sizing: border-box;
          z-index: 100;
          position: absolute;
          top: 100%;
          width: 100%;
          height: fit-content;
          border-radius: 4px;
          background-color: #ffffff;
          border-width: 0px 1px 1px 1px;
          border-style: solid;
          border-color: #edeef3;
          .autocomlete-item {
            padding-left: 40px;
            height: 20px;
            widows: 100%;
            color: #55616e;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            margin: 2px 0px 5px 0px;
          }
          :hover {
            background-color: #edeef3;
          }
        }
        .campaign-name {
          width: calc(70% - 15px);
        }
        .type {
          width: 30%;
        }
        .start-date {
          width: calc(50% - 7.5px);
        }
        .list {
          width: calc(50% - 7.5px);
        }
      }
      .phone-numbers {
        min-height: 40px !important;
      }
      .chips-header {
        height: 15px;
        margin-bottom: 10px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 12px;
        line-height: 15px;
      }
      .chips-row {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .chip-selected {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 7px 10px 15px;
          box-sizing: border-box;
          height: 44px;
          width: 165px;
          border-radius: 4px;
          background-color: #51a3f3;
          color: #ffffff;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          margin-bottom: 20px;
          margin-right: 20px;
          .icon {
            cursor: pointer;
            fill: #ffffff;
            border-radius: 50%;
          }
        }
      }
      .chip {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 7px 10px 15px;
        box-sizing: border-box;
        height: 44px;
        width: 165px;
        border-radius: 4px;
        background-color: #f8f9fe;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        .icon {
          cursor: pointer;
          fill: #55616e;
          border-radius: 50%;
        }
      }
      .chips-header-selected {
        color: #bdbfd8;
        font-family: ""Helvetica Neue"";
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.21px;
        line-height: 15px;
        margin-bottom: 10px;
      }
    }
  }
  .add-campaign-container {
    .nav-header {
      width: 100%;
      height: 50px;
      background-color: #fff;
      display: flex;
      margin-bottom: 18px;
      p {
        cursor: pointer;
        height: calc(100% - 2px);
        display: flex;
        align-items: center;
        padding: 0px 5px 0px 5px;
        margin-right: 10px;
        color: #bdbfd8;
        font-family: ""Helvetica Neue"";
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
      }
      .active {
        color: #51a3f3;
        border-bottom: 2px solid #51a3f3;
      }
    }
    .add-campaign-body {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0;
      .col {
        width: calc(50% - 7.5px);
        .additional-title {
          width: 100%;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 13px;
          line-height: 15px;
          margin-bottom: 15px;
        }
        .check-box-container {
          width: 100%;
          height: 24px;
          margin-bottom: 15px;
        }
        .times-menu-container {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          p {
            cursor: pointer;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 20px;
          }
          .add-more {
            color: #51a3f3;
            margin-right: 15px;
          }
          .remove {
            color: red;
          }
        }
        .time-container {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        .weekdays-from {
          width: calc(50% - 7.5px);
          margin-bottom: 15px;
        }
        .run-from {
          width: calc(25% - 7.5px);
          margin-bottom: 15px;
        }
        .run-until {
          width: calc(25% - 7.5px);
        }
        .delivery-speed {
          width: 100%;
        }
        .text-area {
          height: 120px;
          margin-bottom: 5px;
        }
        .text-area-caption {
          height: 12px;
          margin-left: 15px;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 10px;
          line-height: 12px;
          margin-bottom: 15px;
        }
        .token-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 13px;
          line-height: 15px;
          margin-bottom: 10px;
        }
        .token-container {
          display: flex;
          flex-wrap: wrap;
          .secondary-button {
            width: auto !important;
            padding-left: 20px;
            padding-right: 20px;
            margin-right: 15px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
  .primary-input-container {
    width: 100%;
    .pimary-input-title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 0.21px;
      line-height: 15px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .primary-select-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      background-color: #ffffff;

      ::placeholder {
        color: #55616e;
      }
      .calendar-class {
        width: fit-content !important;
        height: fit-content !important;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .date-wrapper {
        width: 100%;
        height: 100%;
      }
      .vdp-datepicker {
        div {
          width: 100%;
          height: 100%;
        }
      }
      .date-picker {
        width: 100%;
        height: 100%;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        border: none;
      }
      select:focus {
        border: 1px solid #51a3f3;
      }
      .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
      }
    }
  }
}
.multiselect {
  font-family: "Helvetica Neue";
  .multiselect__tags {
    padding-left: 15px;
    .multiselect__single {
      color: black;
      font-size: 14px !important;
      padding: 0;
    }
    .multiselect__placeholder {
      color: #55616e;
    }
  }
}
</style>

